import type {FC} from 'react';

import type {OrderFormSchema} from 'components/content-blocks/order-form/schema';

import {OrderFormDraft} from './draft';
import {OrderFormServer} from './server';

type Props = {
	section: OrderFormSchema;
	isDraft: boolean;
};

export const OrderForm: FC<Props> = ({section, isDraft}: Props) => {
	return isDraft ? <OrderFormDraft section={section} /> : <OrderFormServer section={section} />;
};
